import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionLike } from 'rxjs';

export interface TypedNgbModalRef<T> extends NgbModalRef {
  readonly componentInstance: T;
}

export interface TypedNgbModal extends NgbModal {
  open<T>(content: new (...args: any[]) => T, options?: NgbModalOptions): TypedNgbModalRef<T>;
}

export function setupModal<T>(
  modalRef: TypedNgbModalRef<T>,
  setInputs?: (modal: T) => void,
  subscribeOutputs?: (modal: T) => SubscriptionLike | SubscriptionLike[],
): TypedNgbModalRef<T> {
  if (setInputs) {
    setInputs(modalRef.componentInstance);
  }

  if (subscribeOutputs) {
    const subscriptions = subscribeOutputs(modalRef.componentInstance);

    const unsubscribe = () =>
      'length' in subscriptions
        ? subscriptions.forEach(s => s.unsubscribe())
        : subscriptions.unsubscribe();

    modalRef.result.then(unsubscribe, unsubscribe);
  }

  return modalRef;
}
